export default __webpack_public_path__ + "static/media/totalIconSemSobra.699ee1bb.svg";